import { userFilterCategories } from "../../../shared/lookup";
const workflows = [
    {
        id: 30,
        title: '$PM_NAME Meetings',
        notificationName: 'Meeting',
        abbreviation: '$PM_ABBREVIATION-Meeting-',
        notifyingParty: 'PM',
        notify: true,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',

        notifyAttachments: true,

        includePdfjson: false,

        config: {
            description: 'PM Meetings',
            currentModel: 'InspectionDefect',
            currentModelType: 'PMMeeting',
            referenceType: 'Meeting',
            documentType: 'DocumentPMMeeting',


            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: false,
            configurableAssets: true,

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'pm',
                create: 'create',
                list: 'list',
                default: 'list'
            }
        }
    },
    {
        id: 31,
        title: '$SUPPLIER_NAME Meetings',
        notificationName: 'Meeting',
        abbreviation: '$SUPPLIER_ABBREVIATION-Meeting-',
        notifyingParty: 'SUPPLIER',
        notify: true,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',

        notifyAttachments: true,

        includePdfjson: false,

        config: {
            description: 'Supplier Meetings',
            currentModel: 'InspectionDefect',
            currentModelType: 'ContractorMeeting',
            referenceType: 'Meeting',
            documentType: 'DocumentConMeeting',


            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: false,
            configurableAssets: true,

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'supplier',
                create: 'create',
                list: 'list',
                default: 'list'
            }
        }
    },
    {
        id: 32,
        title: '$SUPPLIER_NAME Site Diary',
        notificationName: 'Site Diary',
        abbreviation: 'Diary-',
        notifyingParty: 'SUPPLIER',
        replyingParty: 'PM',
        //REPLY 
        replyEnabled: false,
        replyPeriodOption: "PM_REPLY_PERIOD",
        replyPeriod: 0,

        resubmitPeriodOption: "PM_REPLY_PERIOD",
        resubmitPeriod: 0,

        notify: true,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',

        notifyAttachments: true,
        replyAttachments: true,

        includePdfjson: false,

        config: {
            description: 'Supplier Site Diary',
            currentModel: 'InspectionDefect',
            currentModelType: 'SiteDiary',
            referenceType: 'SiteDiary',
            documentType: 'DocumentDiary',

            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: true,
            configurableReplyTab: true,
            configurableAssets: true,
            configurableReplyingParty: true,

            replyPeriodOptions: ["PM_REPLY_PERIOD", "CUSTOM", "ASKED_ON_COMMUNICATION_FORM"],
            resubmitPeriodOptions: ["PM_REPLY_PERIOD", "CUSTOM"],

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.REPLY_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'site-diary',
                create: 'create',
                list: 'list',
                default: 'list'
            }
        }
    },
    {
        id: 33,
        title: 'Weather',
        notificationName: 'Weather',
        abbreviation: 'Weather-',
        notifyingParty: 'SUPPLIER',
        replyingParty: 'PM',
        //REPLY 
        replyEnabled: false,
        replyPeriodOption: "PM_REPLY_PERIOD",
        replyPeriod: 0,

        resubmitPeriodOption: "PM_REPLY_PERIOD",
        resubmitPeriod: 0,

        notify: true,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',

        notifyAttachments: true,
        replyAttachments: true,

        includePdfjson: false,

        config: {
            description: 'Supplier Weather',
            currentModel: 'InspectionDefect',
            currentModelType: 'Weather',
            referenceType: 'Weather',
            documentType: 'DocumentWeather',


            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: true,
            configurableReplyTab: true,
            configurableAssets: true,
            configurableReplyingParty: true,

            replyPeriodOptions: ["PM_REPLY_PERIOD", "CUSTOM", "ASKED_ON_COMMUNICATION_FORM"],
            resubmitPeriodOptions: ["PM_REPLY_PERIOD", "CUSTOM"],

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.REPLY_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'weather',
                create: 'create',
                list: 'list',
                default: 'list'
            }
        }
    },

]

export default workflows;